/**
 * Created by km on 2017-03-02.
 */
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import './styles.scss'

export default class AudioPlayer extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      isPlaying: false
    }

    // Set up dataLayer for event tracking
    // This assumes we have GTM set up, otherwise not much will happen.
    window.dataLayer = window.dataLayer || []

    this.togglePlayStatus = this.togglePlayStatus.bind(this)
    this.playbackEndedHandler = this.playbackEndedHandler.bind(this)
  }

  render () {
    return (
      <div
        className={`${this.state.isPlaying ? 'playing' : 'paused'} audioplayer`}
      >
        <audio
          onEnded={this.playbackEndedHandler}
          src={this.props.source}
          ref={element => {
            this.player = element
          }}
        />
        <button
          onClick={this.togglePlayStatus}
          className='ui mini blue icon button'
          title={this.props.audioTitle}
        >
          <i className={`${this.state.isPlaying ? 'stop' : 'volume up'} icon`} />
          <span className='label'>{!this.state.isPlaying ? 'so tönts' : 'stop'}</span>
        </button>
      </div>
    )
  }

  togglePlayStatus (event) {
    this.setState({
      isPlaying: !this.state.isPlaying
    })

    if (this.state.isPlaying) {
      this.player.pause()
    } else {
      this.player.play()
      window.dataLayer.push({
        event: 'Audio Interaktiv',
        action: 'Play',
        videoURL: window.location.href,
        videoTitle: this.props.audioTitle
      })
    }
  }

  playbackEndedHandler (event) {
    this.setState({
      isPlaying: false
    })
  }
}
